/**
 * details / summary の開閉アニメーション（height transition）
 * コレクションサイドバー・商品詳細アコーディオン等で共通利用
 */

const ACCORDION_SELECTOR = "[data-js-accordion]";
const PANEL_SELECTOR = "[data-js-accordion-panel]";

/**
 * リフローを発生させて height transition を確実に起動する
 */
function forceReflow(element: HTMLElement): void {
  void element.offsetWidth;
}

function openAccordion(details: HTMLDetailsElement, panel: HTMLElement): void {
  details.dataset.jsAccordionAnimating = "true";
  details.open = true;
  panel.style.overflow = "hidden";
  panel.style.height = "0px";
  forceReflow(panel);
  panel.style.height = `${panel.scrollHeight}px`;

  const onTransitionEnd = (event: TransitionEvent): void => {
    if (event.target !== panel || event.propertyName !== "height") return;
    panel.style.height = "auto";
    panel.style.overflow = "";
    delete details.dataset.jsAccordionAnimating;
    panel.removeEventListener("transitionend", onTransitionEnd);
  };
  panel.addEventListener("transitionend", onTransitionEnd);
}

function closeAccordion(details: HTMLDetailsElement, panel: HTMLElement): void {
  details.dataset.jsAccordionAnimating = "true";
  panel.style.overflow = "hidden";
  panel.style.height = `${panel.scrollHeight}px`;
  forceReflow(panel);
  panel.style.height = "0px";

  const onTransitionEnd = (event: TransitionEvent): void => {
    if (event.target !== panel || event.propertyName !== "height") return;
    details.open = false;
    panel.style.height = "0px";
    panel.style.overflow = "";
    delete details.dataset.jsAccordionAnimating;
    panel.removeEventListener("transitionend", onTransitionEnd);
  };
  panel.addEventListener("transitionend", onTransitionEnd);
}

function initDetailsAccordion(details: HTMLDetailsElement): void {
  if (details.dataset.jsAccordionInitialized === "true") return;

  const summary = details.querySelector("summary");
  const panel = details.querySelector<HTMLElement>(PANEL_SELECTOR);
  if (!summary || !panel) return;

  details.dataset.jsAccordionInitialized = "true";

  if (details.open) {
    panel.style.height = "auto";
  } else {
    panel.style.height = "0px";
  }

  summary.addEventListener("click", (event) => {
    event.preventDefault();
    if (details.dataset.jsAccordionAnimating === "true") return;

    if (details.open) {
      closeAccordion(details, panel);
    } else {
      openAccordion(details, panel);
    }
  });
}

export function initDetailsAccordionAll(root: ParentNode = document): void {
  root.querySelectorAll<HTMLDetailsElement>(ACCORDION_SELECTOR).forEach(initDetailsAccordion);
}
